import { useEffect } from "react";
import "./InativarEmail.css";

export default function InativarEmail({ open, titulo, onClose, onConfirmar, onConfirm }) {
  if (!open) return null;

  const submit = onConfirmar || onConfirm || (() => {});

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  const onKeyDown = (e) => {
    if (e.key === "Escape") onClose?.();
    if (e.key === "Enter") submit();
  };

  return (
    <div className="emoff-bg" onKeyDown={onKeyDown} tabIndex={-1}>
      <div className="emoff-box" role="dialog" aria-modal="true" aria-label="Inativar e-mail">
        <header className="emoff-head">
          <h3 className="emoff-title">Inativar e-mail</h3>
          <button className="emoff-x" type="button" onClick={onClose} aria-label="Fechar">
            x
          </button>
        </header>

        <div className="emoff-body">
          Deseja <strong>inativar</strong> "{titulo || "este e-mail"}"?
        </div>

        <footer className="emoff-foot">
          <button className="emoff-btn" type="button" onClick={onClose}>
            Cancelar
          </button>
          <button className="emoff-btn emoff-btn-warn" type="button" onClick={submit}>
            Inativar
          </button>
        </footer>
      </div>
    </div>
  );
}
